/*
 * @description: permission权限控制
 * @Author: Jay
 * @Date: 2026-02-28 15:51:41
 * @LastEditors: Jay
 * @LastEditTime: 2026-08-07 14:55:11
 */
// import store from '@/store'
import {
    sessionStorage
} from "@/utils/localstorage"

// 测试-所用权限
// let data = ['kft_fq1', 'kft_fq2', 'kft_fq3', 'kft_fq4', 'kft_fq5']

export default {
    inserted(el, binding) {
        const { value } = binding
        // 刷新后 就获取不到
        // const permissions = store.permission && store.permission.roles
        //  直接获取缓存
        const permissions = sessionStorage.get("rolesPower")
        // console.log("权限", permissions)


        // 测试权限
        // const permissions = data


        if (value && value instanceof Array && value.length > 0) {
            const hasPermission = permissions.some(perm => {
                return value.includes(perm)
            })

            if (!hasPermission) {
                el.parentNode && el.parentNode.removeChild(el)
            }
        } else {
            throw new Error(`需要指定权限标识! 如 v-permission="['add','name']"`)
        }
    }
}


/**
 * 字符权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
export function checkPermissionArr(value) {
    if (value && value instanceof Array && value.length > 0) {

        //  直接获取缓存
        const permissions = sessionStorage.get("rolesPower")

        // 测试权限
        // let permissionIds = data
        // console.log("权限", permissions)


        const permissionArr = value
        const hasPermission = permissions.some(permission => {
            return permissionArr.includes(permission)
        })

        if (!hasPermission) {
            return false
        }
        return true
    } else {
        console.error('暂无权限')
        return false
    }
}

/**
 * 使用方法

    js 导入
        <script>
        import { checkPermissionArr } from '@/directives/permission' // 权限判断函数

        export default{
        methods: {
            checkPermissionArr
        }
        }
        </script>
    
    组件使用
    <el-tab-pane label="负荷跟踪" name="first" v-if="checkPermissionArr(['load_track'])">
        内容
    </el-tab-pane>
 */

/**
   <button v-permission="['admin']">Admin Button</button>
  
 */

